import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Notyf } from "notyf";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import PankuzuHeader from "../components/PankuzuHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSimulation',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const store = useStore();
const route = useRoute();
const props = __props;

const notyf = new Notyf();

//ぱんくずヘッダー
const currentPathList = [
  { name: "在庫管理" },
  { name: "在庫シミュレーション" },
];
// ストアの初期化
store.commit("search/clearAuthData");

//検索ヘッダ関連----------------------------------------------
let isActive_KaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);

const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "PReference_TableContainer_Short";
  } else {
    //その他
    return "PReference_TableContainer_Long";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PSimulation", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"])
  ], 2))
}
}

})